<template>
  <div class="product-detail">
    <div class="product-detail-box">
      <div class="product-detail-title">
        <img :src="url">
        <div class="info">
          <div class="info-title">{{ $t('productCenter.tabs.hpcm') }}</div>
          <div class="info-text">{{ productDescription }}</div>
          <el-button 
            style="height: 43px;"
            type="primary" 
            @mouseenter.native="mouseenter" 
            @mouseleave.native="mouseleave"
          >
            {{ btnText }}
            <img 
              v-if="showcloudDownloadImg" 
              style="margin-right: 0;height: 15px;position: relative;top: 2px;" 
              :src="cloudDownload"
            >
          </el-button>
        </div>
      </div>
    </div>
    <div class="product-detail-info">
      <div class="list">
        <div class="list-title">{{ $t('productCenter.common.productFeatures') }}</div>
        <div class="list-item" v-for="feature in productFeatures" :key="feature"><span></span><p>{{ feature }}</p></div>
      </div>
          
      <div class="list">
        <div class="list-title">{{ $t('productCenter.common.typicalApplications') }}</div>
        <div class="list-item" v-for="application in typicalApplications" :key="application"><span></span><p>{{ application }}</p></div>
      </div>

      <div class="table">
        <div class="table-title">{{ $t('productCenter.common.technicalParameters') }}</div>
        <el-table
          :data="tableData"
          stripe
          border
          style="width: 100%">
            <el-table-column
              prop="project"
              :label="$t('productCenter.common.project')"
              width="150">
              <template slot-scope="scope">
                <span class="multiline">{{ scope.row.project.replace(/｜/g, '\n') }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="test"
              :label="$t('productCenter.common.testMethod')"
              align="center"
              width="150">
            </el-table-column>
            <el-table-column
              prop="parameter1"
              align="center"
              width="150"
              label="HPCM300">
            </el-table-column>
            <el-table-column
              prop="parameter2"
              align="center"
              width="150"
              label="HPCM500">
            </el-table-column>
            <el-table-column
              prop="parameter3"
              align="center"
              width="150"
              label="HPCM600*">
            </el-table-column>
            <el-table-column
              prop="parameter4"
              align="center"
              width="150"
              label="HPCM700">
            </el-table-column>
            <el-table-column
              prop="parameter5"
              align="center"
              width="150"
              label="HPCM801">
            </el-table-column>
            <el-table-column
              prop="parameter6"
              align="center"
              width="149"
              label="HPCM800">
            </el-table-column>
        </el-table>

        <el-table class="customTable" :data="tableDataTwo" style="margin-top: 24px;" border stripe>
          <!-- 父级表头：只有一个“综合信息” -->
          <el-table-column :label="$t('productCenter.common.thermalResistanceVsPressure')">
            <el-table-column prop="project">
              <template slot-scope="scope">
                <span class="multiline">{{ scope.row.project.replace(/｜/g, '\n') }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="test" align="center"></el-table-column>
            <el-table-column prop="parameter1" align="center"></el-table-column>
            <el-table-column prop="parameter2" align="center"></el-table-column>
            <el-table-column prop="parameter3" align="center"></el-table-column>
            <el-table-column prop="parameter4" align="center"></el-table-column>
            <el-table-column prop="parameter5" align="center"></el-table-column>
            <el-table-column prop="parameter6" align="center"></el-table-column>
          </el-table-column>
        </el-table>
        <div class="annotation">{{ $t('productCenter.common.annotation') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      url: require('@/assets/images/productCenter/product1.png'),
      cloudDownload: require('@/assets/images/cloud-download.png'),
      isMouseOver: false,
      tableData: [
        {
          project: this.$t('productCenter.common.color'),
          test: this.$t('productCenter.common.visualInspection'),
          parameter1: this.$t('productCenter.common.gray'),
          parameter2: this.$t('productCenter.common.gray'),
          parameter3: this.$t('productCenter.common.gray'),
          parameter4: this.$t('productCenter.common.gray'),
          parameter5: this.$t('productCenter.common.gray'),
          parameter6: this.$t('productCenter.common.gray'),
        },
        {
          project: this.$t('productCenter.common.phaseChangeTemp') + '｜(℃）',
          test: '-',
          parameter1: '45',
          parameter2: '45',
          parameter3: '45',
          parameter4: '45',
          parameter5: '45',
          parameter6: '45',
        },
        {
          project: this.$t('productCenter.common.density') + '｜(g/cm³)',
          test: 'ASTM D792',
          parameter1: '2.2',
          parameter2: '2.3',
          parameter3: '2.3',
          parameter4: '2.7',
          parameter5: '2.8',
          parameter6: '2.8',
        },
        {
          project: this.$t('productCenter.common.workingTemp') + '｜(℃）',
          test: '-',
          parameter1: '-40~125',
          parameter2: '-40~125',
          parameter3: '-40~125',
          parameter4: '-40~125',
          parameter5: '-40~125',
          parameter6: '-40~125',
        },
        {
          project: this.$t('productCenter.common.volumeResistivity') + '｜(Ω.cm)',
          test: 'ASTM D257',
          parameter1: '10¹⁴',
          parameter2: '10¹⁴',
          parameter3: '10¹⁴',
          parameter4: '10¹⁴',
          parameter5: '10¹⁴',
          parameter6: '10¹⁴',
        },
        {
          project: this.$t('productCenter.common.thermalConductivity') + '｜(W/m-K)',
          test: 'ASTM D5470',
          parameter1: '2.5',
          parameter2: '5.0',
          parameter3: '4.5',
          parameter4: '6.5',
          parameter5: '8.0',
          parameter6: '8.5',
        },
      ],
      tableDataTwo: [
        {
          project: this.$t('productCenter.common.pressure') + '｜(psi)',
          test: '-',
          parameter1: '10/50',
          parameter2: '10/50',
          parameter3: '10/50',
          parameter4: '10/50',
          parameter5: '10/50',
          parameter6: '10/50',
        },
        {
          project: this.$t('productCenter.common.thermalResistance') + '｜(℃-cm²/W)',
          test: 'ASTM D5470',
          parameter1: '0.18/0.10',
          parameter2: '0.14/0.08',
          parameter3: '0.015/0.08',
          parameter4: '0.13/0.07',
          parameter5: '0.11/0.053',
          parameter6: '0.093/0.045',
        },
      ],
    }
  },
  computed: {
    productDescription() {
      return this.$t('productCenter.product1.description')
    },
    btnText() {
      return this.showcloudDownloadImg ? this.$t('productCenter.downloadManual') : this.$t('productCenter.contactForMore')
    },
    showcloudDownloadImg() {
      return this.isMouseOver ? false : true
    },
    productFeatures() {
      return this.$t('productCenter.product1.features')
    },
    typicalApplications() {
      return this.$t('productCenter.product1.applications')
    }
  },
  methods: {
    mouseenter () {
      this.isMouseOver = true
    },
    mouseleave () {
      this.isMouseOver = false
    }
  }
}
</script>

<style lang="scss" scoped>
.product-detail {
  .product-detail-box {
    padding: 60px 0;
    background: rgb(248, 250, 253);
  }
  .product-detail-title {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    img {
      margin-right: 40px;
    }
    .info {
      .info-title {
        font-weight: 500;
        font-size: 24px;
        line-height: 34px;
        padding-bottom: 30px;
      }
      .info-text {
        font-weight: 400;
        font-size: 18px;
        line-height: 25px;
        color: rgba(43, 50, 71, 0.7);
        padding-bottom: 30px;
      }
      .el-button {
        background-color: #fff;
        color: rgb(28, 100, 215);
        border-color: rgb(28, 100, 215);
        i {
          display: inline-block;
        }
      }
    }
  }
  .product-detail-info {
    width: 1200px;
    margin: 0 auto;
    padding: 0 0 100px;
    .list {
      padding-top: 60px;
      .list-title {
        font-weight: 500;
        font-size: 24px;
        line-height: 34px;
        padding-bottom: 24px;
      }
      .list-item {
        font-weight: 400;
        font-size: 18px;
        line-height: 25px;
        color: rgba(43, 50, 71, 0.7);
        display: flex;
        align-items: center;
        p {

        }
        span {
          width: 4px;
          height: 4px;
          border-radius: 50%;
          background-color: rgba(43, 50, 71, 0.7);
          margin-right: 8px;
        }
      }
    }
    .table {
      padding-top: 60px;
      .table-title {
        margin-bottom: 24px;
        font-weight: 500;
        font-size: 24px;
        line-height: 34px;
      }
      ::v-deep .el-table__header th {
        background-color: #f5f7fa;
        text-align: center;
        color: rgb(43, 50, 71);
      }
      ::v-deep .el-table--striped .el-table__body tr.el-table__row--striped td.el-table__cell {
        background-color: #f5f7fa;
      }
      ::v-deep .el-table__body td {
        color: rgba(43, 50, 71, 0.7);
      }
      .customTable {
        ::v-deep thead tr:last-child {
          display: none;
        }
      }
      .multiline {
        white-space: pre-line;
        color: rgb(43, 50, 71);
        font-weight: 500;
      }
      .annotation {
        font-weight: 400;
        font-size: 18px;
        line-height: 25px;
        padding-top: 12px;
        color: rgb(43, 50, 71);
      } 
    }
  }
}
</style>